export enum PaymentType {
  Deposit = "deposit",
  TotalAmount = "total_amount",
}
